<template>
    <!-- 该组件显示聚簇显示主页的信息 -->
    <div class="situation-global-index">
        <div class="SGI-data-content">
            <h1 class="SGI-data-title">聚簇显示</h1>


            <div class="SGI-data">

                <!-- 全部产品-饼图 -->
                <div class="SGI-all-product-pie-chart" style="width:455px;height:400px;">

                    <div id="all_products_pchart" style="width:100%;height:278px;">

                    </div>

                </div>

                <!-- 产品消耗时间状况-饼图 -->
                <div class="SGI-time-product-pie-chart" style="width:455px;height:400px;">
                    <div id="time_products_pchart" style="width:100%;height:278px;">


                    </div>
                </div>








            </div>



        </div>


        <!-- 动态统计柱状图  -->
        <div class="chart-container">
            <!-- 返回按钮（仅在下钻视图显示） -->
            <div v-if="currentProduct" class="drill-header">
                <el-button size="small" @click="backToProductView">
                    <i class="el-icon-arrow-left"></i> 返回产品视图
                </el-button>
                <h3>{{ currentProduct.name }} - Sprint动态统计</h3>
            </div>
            <!-- 图表容器 -->
            <div ref="chart" style="width: 100%; height: 500px;"></div>


            <!-- 分页--为了预防未来项目太多 -->
            <div class="block">
                <el-pagination v-if="!currentProduct" layout="prev, pager, next" :total="totalCnt" :page-size="10"
                    :current-page="currentPage" @current-change="handlePageChange">
                </el-pagination>
            </div>



        </div>


        <!-- 统计间隔时间条状图 -->


        <div id="mychart" class="myChartStyle" style="width: 100%; height: 500px;"></div>






    </div>


</template>


<script>
// 引入 ECharts
import * as echarts from 'echarts';
// 引入 axios
import axios from 'axios';
// 引入 uri
import uri from '@/util/constant';



export default {
    data() {
        return {
            // yData: ["名医直通车", "系统1", "系统2", "系统3", "系统4", "系统5", "系统6"],  //  条状图纵坐标轴
            // xData: [23, 24, 18, 25, 27, 28, 100],  //  条状图横坐标轴

            yData: [],                                              // 条状图纵坐标
            xData: [],                                              // 条状图横坐标
            myChart: null,                                          // 存储间隔时间条状图实例

            situationGlobalData: [],                                //  頭部展示数据數組  
            situationGlobalCharts: [],                              //  图表所需样例


            //  下面这一组是饼状图里所需的前端数据
            frontAllProductCnt: 0,                                  //  所有产品的数量
            frontFinishedProductCnt: 0,                             //  所有已完成的产品数量
            frontUnstartedProjectCnt: 0,                            //  所有未开始的产品数量
            frontDevelopingProjectCnt: 0,                           //  所有正在进行中的产品数量
            frontOtherProject: 0,                                   //  其他状态


            // **************全部产品的饼状图数据*******************

            all_products_pchart: null,                                                              //  饼状图实例
            allProductDataArraySymbol: ['已完成的产品', '进行中的产品', '未开始的产品', '其他状态'],                                 //  饼图下面的颜色提示小标

            opinionDataAll: [                                                                         //  饼图里面的显示部分
                { value: 13, name: '已完成的产品' },
                { value: 19, name: '进行中的产品' },
                { value: 20, name: '未开始的产品' },
                { value: 20, name: '其他状态' },
            ],

            // **************全部产品的饼状图数据********************



            // **************时间消耗产品的饼状图数据*******************
            time_products_pchart: null,
            timeProductDataArraySymbol: ['消耗时间超过一半', '消耗时间未超过一半'],

            opinionDataTime: [                                                                         //  饼图里面的显示部分
                { value: 13, name: '消耗时间超过一半' },
                { value: 19, name: '消耗时间未超过一半' },
            ],


            // **************时间消耗产品的饼状图数据*******************


            // **************************静态定义的钻取图数据

            currentPage: 1,       // 当前页数
            totalCnt: 0,           // 获取的所有数量
            chart: null,
            currentProduct: null, // 当前下钻的产品

            // 产品数据
            productData: [
                { id: 1, name: '产品A', counts: [12, 8, 15, 6, 10] },
                { id: 2, name: '产品B', counts: [5, 7, 9, 12, 8] },
                { id: 3, name: '产品C', counts: [3, 6, 8, 4, 7] }
            ],

            // Sprint数据
            sprintData: {
                1: [ // 产品A的Sprints
                    { id: 101, name: 'Sprint 1', date: '2023-11-01', trends: 5 },
                    { id: 102, name: 'Sprint 2', date: '2023-11-15', trends: 8 },
                    { id: 103, name: 'Sprint 3', date: '2023-12-01', trends: 12 }
                ],
                2: [ // 产品B的Sprints
                    { id: 201, name: 'Sprint 4', date: '2023-11-10', trends: 6 },
                    { id: 202, name: 'Sprint 5', date: '2023-11-25', trends: 9 }
                ],
                3: [ // 产品C的Sprints
                    { id: 301, name: 'Sprint 6', date: '2023-11-05', trends: 4 },
                    { id: 302, name: 'Sprint 7', date: '2023-11-20', trends: 7 },
                    { id: 303, name: 'Sprint 8', date: '2023-12-05', trends: 10 }
                ]
            },

            // 近五日日期
            dateRange: []
            // dateRange: this.generateDateRange()

            // **************************静态定义的钻取图数据


        };
    },

    async created() {

        await this.getProductTrendsCountByPages();
        // await this.getProductTrendsCount();
        await this.getSituationGlobalData();
        await this.getProductTimeBetweenPlanAndFact();
        await this.generateDateRange();
    },

    mounted() {


        // this.initChart();                                       // 先初始化一个钻取图实例
        // this.renderProductChart();                              // 再钻取图渲染数据

    },


    beforeDestroy() {
        // 组件销毁时移除监听并销毁图表
        // window.removeEventListener('resize', this.handleResize);
        // if (this.myChart) {
        //     this.myChart.dispose();
        // }
    },





    // 方法区
    methods: {

        // ***************钻取


        // 分页
        async handlePageChange(newPage) {
            console.log("newPage="+newPage);
            this.currentPage = newPage; // 第一步：先更新页码

            await this.getProductTrendsCountByPages();



        },


        //  分页获取产品动态数量信息
        async getProductTrendsCountByPages() {


            // console.log(this.currentPage);

            var token = localStorage.getItem('jwttoken');

            this.axios.defaults.headers.common["token"] = token;

            await this.axios.get(uri.serverUrl + "/situationgl/situationgl/getNearFiveDaysSprintTrendsByPages?current=" + this.currentPage).then(res => {

                // console.log(res.data);
                this.totalCnt = res.data.total;  //  获取所有数量

                this.productData = [];     //  先清空数组
                //  循环添加
                for (let i = 0; i < res.data.records.length; i++) {

                    // { id: 1, name: '产品A', counts: [12, 8, 15, 6, 10] },
                    let id = res.data.records[i].id;
                    let name = res.data.records[i].name;
                    let counts = [res.data.records[i].oneCount, res.data.records[i].twoCount, res.data.records[i].threeCount, res.data.records[i].fourCount, res.data.records[i].fiveCount];
                    this.productData.push({ id, name, counts });

                }
                // console.log(this.productData);



            })
            this.generateDateRange();

        },





        // 初始化图表
        initChart() {

            this.chart = echarts.init(this.$refs.chart);
            window.addEventListener('resize', this.handleResize);
            // console.log("1.初始化近五日柱状图");
        },


        // 获取目标产品下所有Sprint近五天的动态数量
        async getTargetProductTrendsCount(id) {

            this.sprintData = [];      //  先清空数组

            var token = localStorage.getItem('jwttoken');

            this.axios.defaults.headers.common["token"] = token;

            await this.axios.get(uri.serverUrl + "/situationgl/situationgl/getNearFiveDaysSprintTrends?id=" + id).then(res => {

                //  循环添加
                for (let i = 0; i < res.data.length; i++) {

                    // { id: 1, name: '产品A', counts: [12, 8, 15, 6, 10] },
                    let id = res.data[i].id;
                    let name = res.data[i].name;
                    let counts = [res.data[i].oneCount, res.data[i].twoCount, res.data[i].threeCount, res.data[i].fourCount, res.data[i].fiveCount];
                    this.sprintData.push({ id, name, counts });

                }
                console.log(this.sprintData);

            })


        },




        // 获取所有产品的近五天动态数量
        async getProductTrendsCount() {


            this.productData = [];     //  先清空数组

            var token = localStorage.getItem('jwttoken');

            this.axios.defaults.headers.common["token"] = token;

            await this.axios.get(uri.serverUrl + "/situationgl/situationgl/getNearFiveDaysProductTrends").then(res => {

                //  循环添加
                for (let i = 0; i < res.data.length; i++) {

                    // { id: 1, name: '产品A', counts: [12, 8, 15, 6, 10] },
                    let id = res.data[i].id;
                    let name = res.data[i].name;
                    let counts = [res.data[i].oneCount, res.data[i].twoCount, res.data[i].threeCount, res.data[i].fourCount, res.data[i].fiveCount];
                    this.productData.push({ id, name, counts });

                }
                // console.log(this.productData);

            })


            this.generateDateRange();

            // this.dateRange = dates;


        },


        // 生成近五日日期范围
        async generateDateRange() {

            this.dateRange = [];

            // const dates = [];

            // for (let i = 4; i >= 0; i--) {
            //     const date = new Date();
            //     date.setDate(date.getDate() - i);
            //     dates.push(date.toISOString().split('T')[0]);
            // }



            var token = localStorage.getItem('jwttoken');

            this.axios.defaults.headers.common["token"] = token;

            await this.axios.get(uri.serverUrl + "/situationgl/situationgl/getNearFiveDate").then(res => {

                this.dateRange = res.data
            })
            this.initChart();
            this.renderProductChart();



        },

        // 渲染产品视图
        renderProductChart() {
            this.currentProduct = null;

            const option = {
                title: {
                    text: '产品近五日动态数量统计',
                    left: 'center',
                    textStyle: {
                        fontSize: 16,
                        fontWeight: 'bold'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' },
                    formatter: params => {
                        let result = params[0].name + '<br/>';
                        params.forEach(item => {
                            result += `${item.seriesName}: ${item.value}<br/>`;
                        });
                        return result;
                    }
                },
                legend: {
                    data: this.dateRange,
                    bottom: 10,
                    itemWidth: 12,
                    itemHeight: 8
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '15%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: this.productData.map(p => p.name),
                    axisLabel: {
                        interval: 0,
                        rotate: 30,
                        fontSize: 12
                    },


                },
                yAxis: {
                    type: 'value',
                    name: '动态数量'
                },
                series: this.dateRange.map((date, i) => ({
                    name: date,
                    type: 'bar',
                    data: this.productData.map(p => p.counts[i]),
                    barWidth: '6%',
                    itemStyle: {
                        cursor: 'pointer'
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                })),
                color: ['#5470C6', '#91CC75', '#FAC858', '#EE6666', '#73C0DE']
            };

            this.chart.setOption(option, true);

            // 绑定点击事件
            this.chart.off('click');
            this.chart.on('click', params => {
                if (params.componentType === 'series') {
                    const productId = this.productData[params.dataIndex].id;
                    this.drillDownToSprint(productId);
                }
            });
        },

        // 下钻到Sprint视图
        async drillDownToSprint(productId) {


            //
            const product = this.productData.find(p => p.id === productId);
            if (!product) return;

            this.currentProduct = product;




            await this.getTargetProductTrendsCount(productId);


            const option = {
                title: {
                    text: `${product.name} - Sprint动态统计`,
                    left: 'center',
                    textStyle: {
                        fontSize: 16,
                        fontWeight: 'bold'
                    }
                },
                tooltip: {

                    trigger: 'axis',
                    axisPointer: { type: 'shadow' },
                    formatter: params => {
                        let result = params[0].name + '<br/>';
                        params.forEach(item => {
                            result += `${item.seriesName}: ${item.value}<br/>`;
                        });
                        return result;
                    }

                },
                //  拿的产品的用用  下面这个
                legend: {
                    data: this.dateRange,
                    bottom: 10,
                    itemWidth: 12,
                    itemHeight: 8
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: this.sprintData.map(s => s.name),
                    axisLabel: {
                        interval: 0,
                        rotate: 30,
                        fontSize: 12
                    },

                },
                yAxis: {
                    type: 'value',
                    name: '动态数量'
                },
                series: this.dateRange.map((date, i) => ({
                    name: date,
                    type: 'bar',
                    data: this.sprintData.map(s => s.counts[i]),
                    barWidth: '6%',
                    itemStyle: {
                        // cursor: 'pointer'    //  移除指针
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                })),
            };

            //  原来的图设置为新样式
            this.chart.setOption(option, true);



            // 移除所有图表点击事件（确保不会二次下钻）
            this.chart.off('click');
        },

        // 返回产品视图
        backToProductView() {
            this.renderProductChart();
        },

        // 处理窗口大小变化
        handleResize() {
            this.chart && this.chart.resize();
        },


        // ***************钻取






        //  初始化消耗产品饼状图
        drawLineTimeProducts() {

            //  开始画饼
            // 基于准备好的dom，初始化echarts实例
            this.time_products_pchart = this.$echarts.init(document.getElementById('time_products_pchart'));
            // 绘制图表
            this.time_products_pchart.setOption({
                title: {
                    text: '产品消耗时间状态', // 主标题
                    subtext: '', // 副标题
                    x: 'center' // x轴方向对齐方式
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',

                    bottom: 'bottom',
                    data: this.timeProductDataArraySymbol
                },
                series: [
                    {
                        name: '数据',
                        type: 'pie',
                        radius: '50%',
                        center: ['50%', '50%'],
                        data: this.opinionDataTime,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },
                            color: function (params) {
                                // 自定义颜色
                                var colorList = ['#FADA54', '#81CAC3']
                                return colorList[params.dataIndex]
                            }
                        }
                    }
                ]
            })



        },


        //  初始化全部产品饼状图
        drawLineAllProducts() {


            // console.log("开始画饼图")
            // 基于准备好的dom，初始化echarts实例
            this.all_products_pchart = this.$echarts.init(document.getElementById('all_products_pchart'));
            // 绘制图表
            this.all_products_pchart.setOption({
                title: {
                    text: '全部产品状态', // 主标题
                    subtext: '', // 副标题
                    x: 'center' // x轴方向对齐方式
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',

                    bottom: 'bottom',
                    data: this.allProductDataArraySymbol
                },
                series: [
                    {
                        name: '数据',
                        type: 'pie',
                        radius: '50%',
                        center: ['50%', '50%'],
                        data: this.opinionDataAll,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },
                            color: function (params) {
                                // 自定义颜色
                                var colorList = ['#FADA54', '#81CAC3', 'blue', 'aqua']
                                return colorList[params.dataIndex]
                            }
                        }
                    }
                ]
            })
        },






        //  初始化间隔时间条状图方法
        initEcharts() {
            const chartDom = document.getElementById('mychart');
            this.myChart = echarts.init(chartDom);

            const option = {
                title: {
                    text: '各产品预设结束日期与现实日期间隔',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',  //  左间距
                    right: '10%',  //  右间距
                    bottom: '5%',  //  下间距
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    name: '间隔天数',
                    length: 6,

                },
                yAxis: {
                    type: 'category',
                    data: this.yData,
                    name: '产品名称',
                    axisLabel: {
                        rotate: 45  // 标签旋转防止重叠
                    }
                },
                series: [{
                    data: this.xData,
                    type: 'bar',
                    barWidth: '20%',
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#83bff6' },
                            { offset: 1, color: '#188df0' }
                        ])
                    },
                    emphasis: {
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#2378f7' },
                                { offset: 1, color: '#83bff6' }
                            ])
                        }
                    }
                }]
            };

            this.myChart.setOption(option);
        },

        //  获取头部显示数据
        async getSituationGlobalData() {

            var token = localStorage.getItem('jwttoken');

            this.axios.defaults.headers.common["token"] = token;

            this.axios.get(uri.serverUrl + "/situationgl/situationgl/getSituationGlobalData").then(res => {

                // console.log(res.data);

                // this.situationGlobalData = res.data;

                // //  将请求得来的数据放入前端变量中
                // this.frontAllProductCnt = res.data.allProjectCnt;  //  所有产品数量
                // this.frontFinishedProductCnt = res.data.finishedProjectCnt;



                this.opinionDataAll[0].value = res.data.finishedProjectCnt;           //  已完成的产品数量
                this.opinionDataAll[1].value = res.data.developingProjectCnt;         //  进行中的产品数量
                this.opinionDataAll[2].value = res.data.unstartedProjectCnt;          //  未完成的产品数量
                this.opinionDataAll[3].value = res.data.allProjectCnt - res.data.developingProjectCnt - res.data.unstartedProjectCnt - res.data.finishedProjectCnt;

                this.opinionDataTime[0].value = res.data.overHalfTimeProjectCnt;      //  超过一半时间
                this.opinionDataTime[1].value = res.data.belowHalfTimeProjectCnt;     //  低于一半时间







                this.drawLineAllProducts();
                this.drawLineTimeProducts();


            })




            // const xml = await axios.get(uri.serverUrl + "/situationgl/situationgl/getSituationGlobalData");
            // this.situationGlobalData = xml.data.data;
        },

        //   获取间隔条状图所需数据   
        async getProductTimeBetweenPlanAndFact() {
            var token = localStorage.getItem('jwttoken');

            this.axios.defaults.headers.common["token"] = token;

            this.axios.get(uri.serverUrl + "/situationgl/situationgl/getProductTimeBetweenPlanAndFact").then(res => {

                // console.log(res.data);
                this.situationGlobalCharts = res.data;

                for (let i = 0; i < this.situationGlobalCharts.length; i++) {
                    this.xData.push(this.situationGlobalCharts[i].period);
                    this.yData.push(this.situationGlobalCharts[i].name);
                }

                this.initEcharts();

                // console.log(this.situationGlobalCharts[0].name);

            })



        }
    }




};
</script>


<style scoped>
* {
    margin: 0;
    padding: 0;
}

.situation-global-index {
    width: 100%;
    min-height: 800px;


    background-color: #f5f7fa;

    display: flex;
    flex-direction: column;
}




.SGI-data-content {

    display: flex;
    flex-direction: column;
    margin-top: 20px;
    width: 100%;
    min-height: 197px;
    /* background-color: rgba(255, 244, 79); */
    /* background-color: rgb(5, 239, 219); */
    background-color: #f5f7fa;
    /* border-radius: 50px; */
    align-items: center;
    margin: 0 auto;
    justify-content: center;
}

.SGI-data-title {
    color: rgb(0, 47, 167);
    margin-top: 20px;
    margin-bottom: 20px;

}

.SGI-data {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    border: #333;
    background-color: #f5f7fa;
}

.SGI-data-left {
    display: flex;
    flex-direction: column;
    min-height: 100px;
    justify-content: space-around;
}


.SGI-data-right {
    display: flex;
    flex-direction: column;
    min-height: 100px;
    justify-content: space-around;
}

#mychart {
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background: white;
    width: 1000px;
    min-height: 600px;

}

#ans {
    color: blue;
}




/* ****************************钻取 */
.chart-container {
    width: 100%;
    height: 100%;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    position: relative;
}



.drill-header {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 15px;
}

.drill-header h3 {
    margin: 0;
    font-size: 16px;
    color: #333;
}
</style>